import { insertHorizontalRule, isNodeActive, setActiveTool } from "../../../commands/custom-commands";
import { customSchema, validHorizontalRuleTypes, validHorizontalRuleValues } from "../../../schemas/custom-schema";

export default class HorizontalRuleTool {
  constructor(editorView, containerElement) {
    this.view = editorView;
    this.buildContainer();
    this.buildDialog();
    this.bindActions();
    containerElement.appendChild(this.containerElement);
    this.update(editorView);
  }

  buildContainer() {
    this.containerElement = document.createElement("div");
    this.containerElement.className = "editor-button-container";
    this.buttonElement = document.createElement("button");
    this.buttonElement.setAttribute("type", "button");
    this.buttonElement.className = "editor-toolbar-button";
    this.buttonElement.style.anchorName ="--horizontal-rule-anchor";
    this.buttonElement.dataset.action = "horizontal-rule";
    this.buttonElement.setAttribute("aria-expanded", "false");
    this.buttonElement.title = "Regla horizontal";
    const iconSpan = document.createElement("span"),
      labelSpan = document.createElement("span");
    iconSpan.textContent = "Regla horizontal";
    labelSpan.className = "oculto-visual";
    labelSpan.textContent = "Regla horizontal";
    this.buttonElement.appendChild(iconSpan);
    this.buttonElement.appendChild(labelSpan);
    this.containerElement.appendChild(this.buttonElement);
  }

  buildDialog() {
    const buttonsContainer = document.createElement("div");

    this.dialogElement = document.createElement("div");
    this.dialogElement.className = "editor-dialog";
    this.dialogElement.style.positionAnchor = "--horizontal-rule-anchor";
    this.typeInput = document.createElement("select");
    this.typeInput.className = "editor-dropdown";
    validHorizontalRuleTypes.map(({ value, label }) => {
      const option = document.createElement("option");
      option.value = value;
      option.textContent = label;

      return option;
    }).forEach(option => this.typeInput.appendChild(option));

    this.submitButton = document.createElement("button");
    this.submitButton.type = "button";
    this.submitButton.className = "editor-button";
    this.submitButton.textContent = "Agregar";

    buttonsContainer.className = "editor-buttons-container";
    buttonsContainer.appendChild(this.submitButton);

    this.dialogElement.appendChild(this.typeInput);
    this.dialogElement.appendChild(buttonsContainer);

    this.containerElement.appendChild(this.dialogElement);
  }

  bindActions() {
    this.buttonAction = this.buttonClickCallback();
    this.submitAction = this.submitButtonClickCallback();
    this.buttonElement.addEventListener("click", this.buttonAction);
    this.submitButton.addEventListener("click", this.submitAction);
  }

  update(view) {
    const isActive = isNodeActive(view.state, customSchema.nodes.horizontalRule),
      isEnabled = insertHorizontalRule()(view.state, null)
    if(isActive) {
      this.buttonElement.setAttribute("aria-pressed", "true");
    } else {
      this.buttonElement.setAttribute("aria-pressed", "false");
    }

    this.buttonElement.disabled = !isEnabled;
    this.view = view;
  }

  destroy() {
    this.buttonElement.removeEventListener("click", this.buttonAction);
    this.submitButton.removeEventListener("submit", this.submitAction);
    this.containerElement.remove();
    this.containerElement = null;
    this.buttonElement = null;
    this.typeInput = null;
    this.submitButton = null;
    this.dialogElement = null;
    this.buttonAction = null;
    this.submitAction = null;
    this.removeAction = null;
  }

  buttonClickCallback() {
    return () => {
      setActiveTool(this.buttonElement)(this.view.state, this.view.dispatch);
    }
  }

  submitButtonClickCallback() {
    return (event) => {
      event.preventDefault();
      let { value: type } = this.typeInput;

      if(!validHorizontalRuleValues.includes(type)) {
        type === "";
      }

      insertHorizontalRule(type === "" ? {} : { cssClass: type })(this.view.state, this.view.dispatch);
      setActiveTool(null)(this.view.state, this.view.dispatch);
      this.view.focus();
    }
  }
}